import { useEffect, useState } from 'react';

import Lead from "./lead"
// iOS 用 APNG（Safari 对 APNG 解码优于 WebP），安卓用 WebP（体积更小）
import downloadBgPng from '../assets/img/download_bg.png';
import downloadBgWebp from '../assets/img/download_bg.webp';

function checkIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) || 
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}
const Download = (props) => {

    let userAgent = navigator.userAgent;
    var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isWeixin = userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
    var isIos = checkIOS();
    const [isClick, setClick] = useState(null)

    //将url信息复制到剪贴板
    const copyToClipboard = (copytext) => {
        if (navigator.clipboard && window.isSecureContext) {
            // 现代浏览器 API
            navigator.clipboard.writeText(copytext)
                .then(() => {
                    // 可以在这里添加复制成功的提示
                    console.log('链接已复制');
                })
                .catch(() => {
                    // 如果剪贴板API失败，使用兼容方法
                    fallbackCopyToClipboard(copytext);
                });
        } else {
            // 兼容旧版浏览器
            fallbackCopyToClipboard(copytext);
        }
    };

    const getDownloadUrl = () => {
        fetch(`${process.env.REACT_APP_BASE_URL_DOWNLOAD}/apis/app_version`,{
            headers: {
                'User-Agent': 'Mozilla/5.0 (Linux; U; Android 7.1.2; zh - cn; MI 5X Build/N2G47H) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/61.0.3163.128 Mobile Safari/537.36 XiaoMi/MiuiBrowser/10.4.5'
              }
        }).then(response => response.json())
        .then(res => {
            if (res?.code === 0 && res.data?.downloadApkUrl) {
                // 创建一个隐藏的 a 标签来触发下载
                const downloadLink = document.createElement('a');
                downloadLink.href = res.data.downloadApkUrl;
                downloadLink.setAttribute('download', '通通.apk'); // 设置下载文件名
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
              } else {
                console.error('获取安卓安装包地址失败：', res);
              }
        })
    }

    const fallbackCopyToClipboard = (text) => {
        // 创建临时文本区域
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // 防止滚动到底部
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            // 执行复制命令
            document.execCommand('copy');
            console.log('链接已复制');
        } catch (err) {
            console.error('复制失败', err);
        }

        // 清理临时元素
        document.body.removeChild(textArea);
    };

    useEffect(() => {
        const clickArea = document.querySelector('.action-section')

        if (clickArea) {
            //传参处理
            const { path, ...otherParams } = props.data;
            if(isIos && path && path.indexOf("freeacti") != -1){
                otherParams.business = 9;
            }
            console.log("other params",otherParams);
            
            let baseUrl = path ? decodeURIComponent(path) : '';
            if (path && Object.keys(otherParams).length > 0) {
                let queryString = ''

                // 检查baseUrl是否已包含查询参数
                const hasQueryParams = baseUrl.includes('?');

                // 第一个参数使用 ? 或 & 开始，取决于URL是否已有参数
                let firstConnector = hasQueryParams ? '&' : '?';

                Object.entries(otherParams).forEach(([key, value], index) => {
                    // 第一个参数使用 ? 或 &，后续参数都使用 &
                    queryString += index === 0 ? `${firstConnector}${key}=${value}` : `&${key}=${value}`
                })
                baseUrl = `${baseUrl}${queryString}`
            }
            const ttpath = baseUrl
            
            // otherParams.openMode等于2的时候，自定义打开APP
            if(otherParams.openMode == 2 && isAndroid) {
                // 为 openMode == 2 绑定自定义的处理方法
                const handleOpenMode2Click = () => {
                    window.location.href = process.env.REACT_APP_SCHEME_URL;
                    // 如果 APP 未安装，可以设置超时跳转到下载页
                    setTimeout(() => {
                        // 可以在这里添加跳转到应用商店的逻辑
                        console.log('APP 可能未安装');
                        getDownloadUrl();
                    }, 2000);
                };
                
                clickArea.addEventListener('click', handleOpenMode2Click);
                
                // 清理函数
                return () => {
                    clickArea.removeEventListener('click', handleOpenMode2Click);
                };
            } else {
                //初始化按钮
                new window.JMLink({
                    autoLaunchApp: false,
                    jmlink: process.env.REACT_APP_JMLINK,// 短链地址
                    button: clickArea,
                    params: { ttpath },
                    directDownload: true
                });
                // 添加自定义点击事件
                const handleClick = () => {
                    copyToClipboard(ttpath);
                }
                clickArea.addEventListener('click', handleClick);

                // 清理函数
                return () => {
                    clickArea.removeEventListener('click', handleClick);
                }
            }
        }
    }, [props.data])
    return (
        <div className='download-wrapper'>
            {isAndroid && isWeixin && isClick && <Lead />}
            <div id="content">
                <img
                    className="download-bg"
                    src={isIos ? downloadBgPng : downloadBgWebp}
                    alt=""
                />
                {props.agent == 'weixin' && <div className='tip'>点击右上角使用浏览器打开
                    <svg width="21" height="9" viewBox="0 0 21 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.180913 8.53575C2.35801 7.60271 4.26279 6.13255 5.71698 4.26289L8.13194 1.15792C9.33302 -0.386314 11.667 -0.386312 12.8681 1.15793L15.1622 4.10752C16.6956 6.0791 18.7042 7.62938 21 8.61328H0L0.180913 8.53575Z" fill="#F2F2F4" />
                    </svg>
                </div>}
                <div
                    className="action-section"
                    {...(isAndroid && isWeixin ? { onClick: () => setClick(true) } : {})}
                ></div>
            </div>
        </div >
    )
};

export default Download;